import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordingPipe } from './wording.pipe';

@NgModule({
  imports: [CommonModule, WordingPipe],
  exports: [WordingPipe],
  providers: [WordingPipe],
})
export class WordingModule {}
